<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script type="application/javascript">
    import "@/assets/acute-framework/css/styles.css";
    export default{
        name:'App',
        watch:{
            $route:function(to){
                document.title = to.meta.title || 'Acute Colors';
            }
        }
    }
</script>
<style lang="scss">
body{
    background-color: #333;
}
#app{
    font-size:16px;
}
.color-black{
	color: #000;
}
.color-white{
	color:#FFF;
}
.dropdown__options-wrapper{
    max-height: 30vh;
    overflow-y: scroll;
}
</style>
